import { frontendURL } from '../../../../helper/URLHelper';

import PhoneIndex from './Index.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/phone'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_phone',
          component: PhoneIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
